import isBTMPlan from 'utils/pivot/plan/isBTMPlan'
import getAndValidatePeriod from 'utils/pivot/plan/getAndValidateDuration'

function getExtendDuration(plan, period) {
  if (isBTMPlan(plan)) {
    if (plan.durations.length > 0) {
      return (
        plan.durations[0].extendedDurationsAvailable &&
        plan.durations[0].extendedDurationsAvailable[0]
      )
    }
  }

  const duration = getAndValidatePeriod(plan, period)

  const planPolicies = Object.keys(duration)
  const maxPolicy = planPolicies[planPolicies.length - 1]
  const maxPolicyDuration = duration[maxPolicy]
  return (
    maxPolicyDuration.extendedDurationsAvailable &&
    maxPolicyDuration.extendedDurationsAvailable[0]
  )
}

export default getExtendDuration
